import { requireSupabase } from "@/lib/supabaseClient";
import { guard } from "@/lib/errors";
import { cached } from "@/lib/cache";

const TTL = 10 * 60 * 1000; // 10 minutes — taxonomy rarely changes

export const taxonomyService = {
  categories: () => cached("tax:categories", () => guard("taxonomy.categories", async () => {
    const s = requireSupabase();
    const { data, error } = await s.from("property_categories").select("*").order("sort_order");
    if (error) throw error; return data || [];
  }), TTL),

  types: () => cached("tax:types", () => guard("taxonomy.types", async () => {
    const s = requireSupabase();
    const { data, error } = await s.from("property_types").select("*").order("name");
    if (error) throw error; return data || [];
  }), TTL),

  amenities: () => cached("tax:amenities", () => guard("taxonomy.amenities", async () => {
    const s = requireSupabase();
    const { data, error } = await s.from("amenities").select("*").order("name");
    if (error) throw error; return data || [];
  }), TTL),

  regions: () => cached("tax:regions", () => guard("taxonomy.regions", async () => {
    const s = requireSupabase();
    const { data, error } = await s.from("regions").select("*").order("name");
    if (error) throw error; return data || [];
  }), TTL),

  cities: (regionId) => cached(`tax:cities:${regionId || "all"}`, () => guard("taxonomy.cities", async () => {
    const s = requireSupabase();
    let q = s.from("cities").select("*").order("name");
    if (regionId) q = q.eq("region_id", regionId);
    const { data, error } = await q;
    if (error) throw error; return data || [];
  }), TTL),
};
